<div class="wedding-wrap">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <h1>Stephen and Emmalyn's Wedding</h1>
        <h3 class="date">Saturday, September 26th, 2026</h3>
        <h3 class="my-5">We can't wait to celebrate with you!</h3>
      </div>

      <div class="col-12 col-sm-8 col-md-7 col-lg-6">
        <ng-container *ngIf="!rsvpSubmitted; else thankYouCard">
          <form class="form-wrapper" (ngSubmit)="onSubmit()" #rsvpForm="ngForm">
            <div class="form-group">
              <label for="attendance">Will you be attending?</label>
              <select class="form-control" id="attendance" name="attendance" [(ngModel)]="attendance" required>
                <option value="" disabled selected>Select an option</option>
                <option value="yes">Yes, I will attend</option>
                <option value="no">No, I cannot attend</option>
              </select>
              <div *ngIf="submitAttempted && !attendance" class="text-danger small mt-1">Please let us know if you can make it.</div>
            </div>
            <div class="form-group">
              <label for="guests">Number of Guests (including yourself)</label>
              <input type="number" class="form-control" id="guests" name="guests" [(ngModel)]="guests" min="1" max="10" required (ngModelChange)="setGuests($event)" pattern="\d*" step="1" (keydown)="preventNonNumericInput($event)">
              <div *ngIf="submitAttempted && (!guests || guests < 1)" class="text-danger small mt-1">Please enter how many people will be coming.</div>
            </div>
            <div class="form-group">
              <label for="guestName">Your Name</label>
              <input type="text" class="form-control" id="guestName" name="guestName" [(ngModel)]="guestName" required>
              <div *ngIf="submitAttempted && !guestName" class="text-danger small mt-1">Who even are you?</div>
            </div>
            <div *ngIf="guests > 1">
              <label>Guest Names:</label>
              <div *ngFor="let name of otherGuestNames; let i = index; trackBy: trackByIndex" class="form-group">
                <input type="text" class="form-control" [id]="'otherGuest' + i" [name]="'otherGuest' + i" [ngModel]="otherGuestNames[i]" (input)="updateOtherGuestName($event.target.value, i)" required>
                <div *ngIf="submitAttempted && (!otherGuestNames[i] || !otherGuestNames[i].trim())" class="text-danger small mt-1">Guest name is required.</div>
              </div>
            </div>
            <button type="submit" class="btn btn-primary mt-3">RSVP</button>
          </form>
        </ng-container>
        <ng-template #thankYouCard>
          <div class="thank-you-card text-center p-5 mt-4 mb-4 bg-light rounded shadow">
            <h2>Thank You!</h2>
            <p>Your RSVP has been received. We'll see you soon!</p>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row text-center my-5">
      <div class="col">
        <h3>Please carpool if possible, parking is limited <3</h3>
      </div>
    </div>
<!--    <div class="row">-->
<!--      <div class="col">-->
<!--        <h3>List</h3>-->
<!--        <table>-->
<!--          <tr>-->
<!--            <th>Name</th>-->
<!--            <th>Guest Count</th>-->
<!--            <th>Is Coming</th>-->
<!--          </tr>-->
<!--          <tr *ngFor="let rsvp of rsvpList">-->
<!--            <td>{{ rsvp.name }}</td>-->
<!--            <td>{{ rsvp.guestCount }}</td>-->
<!--            <td>{{ rsvp.attendance }}</td>-->
<!--          </tr>-->
<!--        </table>-->
<!--    </div>-->
<!--  </div>-->
</div>
</div>
